module.exports = __webpack_public_path__ + "static/media/kangyang-2@2x.83b2c56e.png";